import React, { FC, useEffect, useState } from "react";
import UnreleasedComponent from "../@shared/unreleasedComponent";
import DictionaryTerm from "../@shared/dictionaryTerm";
import RoutableSitecoreLink from "../@shared/routableSitecoreLink";
import Icon from "../@shared/icon";
import { iconSize } from "../../constants/icon.constants";
import { RelatedNewsModel } from "./models/relatedNews.model";
import { withTranslation } from "react-i18next";
import { withSitecoreContext } from "@sitecore-jss/sitecore-jss-react";
import CarouselArrow from "../@shared/carouselArrow";
import Slider from 'react-slick';
import { getCustomPaging } from "../@shared/carouselDots";
import appendDots from "../@shared/customCarouselDots/appendDots";
import { TRelatedNewsCardItemProps, TRelatedNewsProps } from "./types/relatedNews.types";
import RelatedNewsCard from "./components/relatedNewsCard";

const RelatedNews: FC = (props: TRelatedNewsProps) => {

  const model = new RelatedNewsModel(props);
  const [activeCardIndex, setActiveIndex] = useState<number>(0);
  const [isClickedOnArrow, setIsClickedOnArrow] = useState<boolean>(false);
  const cardsLength = model?.items?.length;

  const arrowButtonClick = (): void => {
    setIsClickedOnArrow(true);
  };

  useEffect(() => {
    if (!isClickedOnArrow) {
      return;
    }
    setIsClickedOnArrow(false);
  }, [activeCardIndex]);

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    variableWidth: true,
    slidesToScroll: 1,
    nextArrow: <CarouselArrow direction="next" additionalCssClass="related-news__carousel-arrow" onClickSecondary={arrowButtonClick} />,
    prevArrow: <CarouselArrow direction="previous" additionalCssClass="related-news__carousel-arrow" onClickSecondary={arrowButtonClick} />,
    customPaging: getCustomPaging,
    afterChange: (index: number): void => {
      setActiveIndex(index);
    },
    appendDots: (dots: JSX.Element[]) => appendDots({ dots, cardsCount: cardsLength, activeCardIndex, showCustomDots: cardsLength > 5 }),
    dotsClass: `${cardsLength <= 5 ? 'related-news__carousel-dots' : ''}`,
  };


  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  const cardsMapper = (): JSX.Element[] => {
    const cardsArray = model?.items?.map((item: TRelatedNewsCardItemProps, index) => (
      <RelatedNewsCard
        item={item}
        key={model?.items?.length + index}
        cardHeadingTitleTag={model?.headingTag}
        sitecoreContext={props?.sitecoreContext}
        defaultCardImage={model?.defaultCardImageNarrow}
        socialMediaBarProps={model.socialMediaBarProps}
      />
    ));

    return cardsArray;
  }

  return (
    <div className="related-news">
      <div className="related-news__heading-wrapper">
        <div className="related-news__heading-eyebrow">
          <DictionaryTerm keyword="cnhi-news-related-eyebrow" />
        </div>

        <div className="related-news__heading-text">
          <div className="related-news__heading-title">
            <DictionaryTerm keyword="cnhi-news-related-title" />
          </div>

          <RoutableSitecoreLink field={model?.link} className="related-news__heading-link">
            <DictionaryTerm keyword="cnhi-showAll" />
            <Icon iconName="arrow-simple-right" size={iconSize.dsk} color={'primary'} extraClassName="cta-with-arrow__icon" />
          </RoutableSitecoreLink>
        </div>
      </div>
      <Slider {...settings}>{cardsMapper()}</Slider>
    </div>
  );
}

export default withTranslation()(withSitecoreContext()(RelatedNews));